import { render, staticRenderFns } from "./PeriodScore.vue?vue&type=template&id=f29e13e2&scoped=true&"
import script from "./PeriodScore.vue?vue&type=script&lang=js&"
export * from "./PeriodScore.vue?vue&type=script&lang=js&"
import style0 from "./PeriodScore.vue?vue&type=style&index=0&id=f29e13e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29e13e2",
  null
  
)

export default component.exports